<div class="maintenance">
  <header>
    <div class="header-content">
      <div class="logo-container">
        <img
          src="assets/img/parts-connect-logo.svg"
          alt="Rush Truck Centers Parts Connect"
          width="291"
          height="55"
        />
      </div>
    </div>
  </header>

  <main>
    <div class="container">
      <div class="card">
        <div class="wrench-container">
          <div class="wrench-badge" aria-hidden="true">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="80" height="80" rx="40" fill="#EEB111"></rect>
              <path
                d="M49 46C47.125 46 45.4375 45.7188 43.8438 45.1563L26.7813 62.2188C25.6563 63.3438 23.9688 64 22.2813 64C18.8125 64 16 61.1875 16 57.7188C16 56.0313 16.6563 54.3438 17.7813 53.2188L34.8438 36.1563C34.2813 34.5625 34 32.875 34 31C34 22.75 40.6563 16 49 16C50.4063 16 51.8125 16.2813 53.125 16.6563C54.0625 16.9375 54.3438 18.1563 53.5938 18.9063L46.375 26.125C46.0938 26.4063 46 26.7813 46 27.1563V32.5C46 33.3438 46.6563 34 47.5 34H52.8438C53.2188 34 53.5938 33.9063 53.875 33.625L61.0938 26.4063C61.8438 25.6563 63.0625 25.8438 63.3438 26.875C63.7188 28.1875 64 29.5938 64 31C64 39.3438 57.25 46 49 46ZM23.5 54.25C22.1875 54.25 21.25 55.2813 21.25 56.5C21.25 57.8125 22.1875 58.75 23.5 58.75C24.7188 58.75 25.75 57.8125 25.75 56.5C25.75 55.2813 24.7188 54.25 23.5 54.25Z"
                fill="#111111"
              ></path>
            </svg>
          </div>
        </div>

        <section class="content">
          <h1 class="mb-3">Temporarily Closed for System Upgrades</h1>
          <p class="m-0">
            @if (restoreDateTime$ | async; as restoreDateTime) {
              We are performing scheduled system upgrades. Our website is temporarily offline and will be fully restored by<br />
              {{ restoreDateTime }}. Thank you for your patience.
            } @else {
              We are performing scheduled system upgrades. Our website is temporarily offline and will be fully restored shortly.
              Thank you for your patience.
            }
          </p>
        </section>

        <section class="content">
          <p class="m-0">
            Visit
            <a href="https://www.rushtruckcenters.com/locations/?services=900022">rushtruckcenters.com/locations</a>
            to find a Rush Truck Centers parts location near you.
          </p>
        </section>
      </div>
    </div>
  </main>

  <footer>&copy;2015&ndash;2026 Rush Enterprises Inc. rushtruckcenters.com</footer>
</div>

